import { Avatar, Button, Flex, Tabs, Tooltip, Typography } from 'antd';
import { IoSettingsOutline } from 'react-icons/io5';
import clsx from 'clsx';
import { getInitials } from '../../utils';

const PageHeader = ({
  detail,
  extra,
  tabs,
  defaultActiveTab,
  onTabChange,
  activeKey,
  onEditClick,
}) => {
  return (
    <div className="PageHeader">
      <Flex className={clsx('PageHeader__Top', { 'PageHeader__Top--with-tabs': tabs })} justify="space-between" align="center" wrap="wrap" gap={16}>
        <Flex className="PageHeader__TitleWrapper" align="center" gap={10}>
          <div className="PageHeader__TitleArea">
            <Avatar
              shape="square"
              children={getInitials(detail?.name || '')}
              size={50}
              src={detail?.src}
            />
            <Typography.Title level={2} ellipsis={{ tooltip: detail?.name }}>
              {detail?.name ?? ''}
            </Typography.Title>
          </div>
          {onEditClick && (
            <Tooltip title="Site Setting">
              <Button
                className="PageHeader__EditButton"
                color="primary"
                variant="filled"
                onClick={onEditClick}
                icon={<IoSettingsOutline />}
              />
            </Tooltip>
          )}
        </Flex>
        {extra && (
          <div className="PageHeader__Extra">
            {extra}
          </div>
        )}
      </Flex>
      {tabs && (
        <Tabs
          items={tabs}
          defaultActiveKey={defaultActiveTab}
          activeKey={activeKey}
          onChange={onTabChange}
        />
      )}
    </div>
  );
};

export default PageHeader;
